import analyticsService from "src/services/Analytics.service";

export const trackUploadingStarts = (file: File) =>
  analyticsService.track("uploading-starts", { size: file.size, type: file.type });
